<template>
  <form ref="form" onsubmit="return false" v-loading="!initFinished">
    <div
      :id="containerID"
      class="use-deprecated-styles"
      :data-id="id"
      :data-model-name="dataModelName"
      :data-model-attribute="dataModelAttribute"
      data-manage="1"
      data-sub-header-condition="1"
    >
      <section
        class="segmentsSection"
        v-if="templatesReady && editor"
        :class="{ invisible: !initFinished }"
      >
        <div class="segmentsWrapper">
          <div class="segmentConditions" :data-all-time="showAllTime">
            <input
              type="hidden"
              :name="`${dataModelName}[${dataModelAttribute}][operator]`"
              :value="conditions.operator"
            />
            <el-row
              v-if="Object.keys(conditions).length === 1 && noDataAlert"
              style="width: 100%"
            >
              <el-col class="m-bottom-10 p-top-10" :offset="11" :span="11">
                <span class="no-data">
                  {{ $t('Audience_Segment_Form_NoConditions') }}
                </span>
              </el-col>
            </el-row>
            <template
              v-for="(condition, gLoop) in conditions"
              v-if="typeof condition !== 'string'"
            >
              <div class="conditionOuterWrapper">
                <div class="top-relation relation"></div>
                <div class="bottom-relation relation"></div>

                <div
                  class="conditionWrapper"
                  :class="[
                    condition === 'or' ? 'relations_or' : 'relations_and'
                  ]"
                  :data-number="gLoop"
                >
                  <input
                    type="hidden"
                    :name="
                      `${dataModelName}[${dataModelAttribute}][${gLoop}][operator]`
                    "
                    :value="condition.operator"
                  />
                  <el-row
                    v-if="Object.keys(condition).length === 1 && noDataAlert"
                    style="width: 100%"
                  >
                    <el-col class="m-bottom-10" :offset="11" :span="11">
                      <span class="no-data">
                        {{ $t('Audience_Segment_Form_NoConditions') }}
                      </span>
                    </el-col>
                  </el-row>
                  <div
                    v-for="(subcondition, iLoop) in condition"
                    v-if="typeof subcondition !== 'string'"
                    :class="{
                      'no-delete': Object.keys(condition).length < 3
                    }"
                    :key="iLoop"
                    class="condition-row-wrapper"
                  >
                    <span
                      v-html="
                        renderTemplate(twigTemplates.conditionItem, {
                          modelName: dataModelName,
                          modelAttribute: dataModelAttribute,
                          subcondition: subcondition,
                          model: editor.conditionEntity,
                          gLoop: gLoop,
                          iLoop: iLoop,
                          js: true,
                          preview: preview,
                          showAllTime: showAllTime,
                          displayEventProperties: true,
                          displayEventPropertiesAddButton: checkAddPropertyButton(
                            gLoop,
                            iLoop
                          ),
                          displayEventGoalValue: showEventValueProperty,
                          displayEventGoalValueButton: true
                        })
                      "
                    ></span
                    ><span
                      v-if="!preview"
                      @click="removeConditionRow(gLoop, iLoop)"
                      class="remove-row"
                    ></span>
                    <div class="condition-button-wrapper">
                      <condition-button
                        v-model="condition.operator"
                        :readonly="preview || conditionButtonFixed"
                        :callback="rerender"
                        v-if="
                          condition.operator &&
                            getConditionLastKey(condition) > iLoop
                        "
                      />
                    </div>
                    <div
                      class="choices-container"
                      v-if="!preview"
                      :ref="'choices-container-' + gLoop + '-' + iLoop"
                      :tabindex="Math.floor(Math.random() * 100)"
                    >
                      <segment-category-selector
                        :menu-items="menuData"
                        :title="$t('Audience_Segment_Form_Category_Title')"
                        :selected="subcondition ? subcondition[0] : null"
                        :container.sync="
                          $refs['choices-container-' + gLoop + '-' + iLoop]
                        "
                        v-if="menuData && updateFinished"
                      />
                    </div>
                  </div>
                  <div class="addConditionRowWrapper" v-if="!preview">
                    <el-row>
                      <el-col :span="12">
                        <el-button
                          type="primary"
                          plain
                          class="addRowButton"
                          icon="el-icon-circle-plus-outline"
                          @click="addConditionRow(gLoop)"
                        >
                          {{ $t('Audience_Segment_Form_AddRow') }}
                        </el-button>
                      </el-col>
                      <el-col :span="12" v-if="!singleLevel">
                        <el-button
                          style="float: right"
                          type="danger"
                          plain
                          v-if="Object.keys(conditions).length > 2"
                          icon="el-icon-delete"
                          @click="removeConditionSection(gLoop)"
                        >
                          {{ $t('Audience_Segment_Form_RemoveSection') }}
                        </el-button>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="condition-button-wrapper">
                <condition-button
                  :key="gLoop"
                  :readonly="preview || conditionButtonFixed"
                  :callback="rerender"
                  style="margin: 0 auto"
                  v-model="conditions.operator"
                  v-if="getConditionLastKey(conditions) > gLoop"
                />
              </div>
            </template>
          </div>
        </div>
        <span v-html="renderTemplate(twigTemplates.previewModal, {})"></span>
      </section>

      <el-row v-if="!preview && !singleLevel">
        <el-col>
          <el-button
            type="primary"
            class="addSectionButton"
            icon="el-icon-circle-plus-outline"
            @click="addConditionSection()"
            >{{ $t('Audience_Segment_Form_AddSection') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </form>
</template>

<script>
/* global RELEASE_HASH */

import ConditionsEditor from '@/jquery/widgets/conditionsEditor'
import { baseUrl } from '@/core/helpers'
import { twig } from 'vendor/twig/twig'
import SegmentCategorySelector from '@/modules/audiences/components/SegmentCategorySelector'
import ConditionButton from '@/modules/audiences/components/ConditionButton'
import _ from 'lodash'

export default {
  components: { ConditionButton, SegmentCategorySelector },
  props: {
    id: {
      required: false
    },
    value: {
      type: Object,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    singleLevel: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Object,
      default: null
    },
    dataModelName: {
      type: String,
      required: true
    },
    dataModelAttribute: {
      type: String,
      required: true
    },
    attributeListDataUrl: {
      type: String,
      default: '/segment/segment/attribute-list-data'
    },
    noDataAlert: {
      type: Boolean,
      default: true
    },
    conditionButtonFixed: {
      type: Boolean,
      default: false
    },
    showAllTime: {
      type: Number,
      default: 0
    },
    showEventValueProperty: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      editor: null,
      containerID: 'conditions-editor-' + new Date().getTime(),
      menuData: null,
      conditions: {},
      twigTemplates: {
        conditionHeader: {
          instance: null,
          name: 'condition-header'
        },
        conditionItem: {
          instance: null,
          name: 'condition-item'
        },
        previewModal: {
          instance: null,
          name: 'preview-modal'
        }
      },
      updateFinished: false,
      initFinished: false,
      eventPropLimit: 10,
      eventPropsButtonsDisplay: []
    }
  },

  computed: {
    updateJsonDebounce() {
      return _.debounce(() => {
        this.updateConditionJson()
      }, 500)
    },
    templatesReady() {
      return (
        this.twigTemplates.conditionItem.instance !== null &&
        this.twigTemplates.conditionHeader.instance !== null
      )
    }
  },

  updated() {
    this.updateFinished = true
  },

  async mounted() {
    let initInterval = setInterval(() => {
      let init = $(`#${this.containerID} .segmentConditions`).data('init')
      if (init) {
        this.initFinished = true
        clearInterval(initInterval)
      }
    }, 100)
    $(this.$refs['form']).on('change', () => {
      this.updateJsonDebounce()
    })
    $(document).on('dropdownselection', () => {
      this.updateJsonDebounce()
    })
    document.addEventListener('dropdownselection', () => {
      this.updateJsonDebounce()
    })

    this.bindPropertiesEvents()

    this.conditions = this.value
    this.defineEventPropsButtons()
    for (const template in this.twigTemplates) {
      await this.loadTwigTemplate(this.twigTemplates[template])
    }
    let menuInterval = setInterval(() => {
      if (this.menu) {
        this.menuData = this.menu
        clearInterval(menuInterval)
        return
      }
      let menuData = $(`#${this.containerID} .segmentConditions`).data(
        'attribute-list'
      )
      if (menuData) {
        this.menuData = menuData
        clearInterval(menuInterval)
      }
    }, 100)

    this.$nextTick(function() {
      this.editor = new ConditionsEditor()
      setTimeout(() => {
        this.editor.init(`#${this.containerID}`, this.attributeListDataUrl)
      })
    })
  },

  beforeDestroy() {
    $(this.$refs['form']).off('change')
    $(document).off('dropdownselection')
    if (this.initFinished) {
      this.updateConditionJson()
    }
    $('body').undelegate()
  },

  methods: {
    rerender() {
      this.$forceUpdate()
      this.updateJsonDebounce()
    },
    updateConditionJson() {
      if (this.initFinished) {
        this.$emit('input', this.serialize())
      }
    },

    async loadTwigTemplate(segmentTemplate) {
      return twig({
        href: `${baseUrl('/segment/views/segment/templates/')}${
          segmentTemplate.name
        }.twig?v=${RELEASE_HASH}`,
        async: false,
        load: function(template) {
          segmentTemplate.instance = template
        }
      })
    },

    renderTemplate(template, parameters) {
      return template.instance.render(parameters)
    },

    getConditionLastKey(conditions) {
      let maxKey = null
      for (const key of Object.keys(conditions)) {
        if (!isNaN(key)) {
          if (maxKey === null || key > maxKey) {
            maxKey = parseInt(key)
          }
        }
      }
      return maxKey
    },

    addConditionRow(key) {
      let conditions = this.conditions[key]
      let lastIndex = this.getConditionLastKey(conditions)
      let nextIndex = 0
      if (lastIndex !== null) {
        nextIndex = parseInt(lastIndex) + 1
      }
      conditions[nextIndex] = {}
      this.$forceUpdate()
      this.updateFinished = false
    },

    addEventPropertyRow(condIndex, condItemIndex) {
      let nextIndex = 0
      this.conditions = this.value
      if (this.conditions[condIndex] === undefined) {
        this.conditions[condIndex] = {}
      }
      if (this.conditions[condIndex][condItemIndex] === undefined) {
        this.conditions[condIndex][condItemIndex] = {}
      }
      if (this.conditions[condIndex][condItemIndex][7] === undefined) {
        this.conditions[condIndex][condItemIndex][7] = []
      } else {
        let propertySubConditions = []
        Object.keys(this.conditions[condIndex][condItemIndex][7]).forEach(
          key => {
            propertySubConditions.push(
              Object.values(this.conditions[condIndex][condItemIndex][7][key])
            )
          }
        )
        this.conditions[condIndex][condItemIndex][7] = propertySubConditions
        nextIndex = propertySubConditions.length
      }

      let emptyItem = ['', '=', '']
      this.$set(
        this.conditions[condIndex][condItemIndex][7],
        nextIndex,
        emptyItem
      )
      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    addEventValuePropertyRow(condIndex, condItemIndex) {
      this.conditions = this.value
      if (this.conditions[condIndex] === undefined) {
        this.conditions[condIndex] = {}
      }
      if (this.conditions[condIndex][condItemIndex] === undefined) {
        this.conditions[condIndex][condItemIndex] = {}
      }

      this.conditions[condIndex][condItemIndex][8] = ''

      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    removeEventPropertyRow(condIndex, condItemIndex, propIndex) {
      this.conditions = this.value
      delete this.conditions[condIndex][condItemIndex][7][propIndex]
      let propertySubConditions = []
      Object.keys(this.conditions[condIndex][condItemIndex][7]).forEach(key => {
        if (this.conditions[condIndex][condItemIndex][7][key] !== undefined) {
          propertySubConditions.push(
            Object.values(this.conditions[condIndex][condItemIndex][7][key])
          )
        }
      })
      this.conditions[condIndex][condItemIndex][7] = propertySubConditions
      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    removeEventValuePropertyRow(condIndex, condItemIndex) {
      this.conditions = this.value
      this.conditions[condIndex][condItemIndex][8] = null

      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    parseDates() {
      Object.keys(this.conditions).forEach(key => {
        Object.keys(this.conditions[key]).forEach(subKey => {
          if (
            this.conditions[key][subKey][4] !== undefined &&
            ['between', 'between_time'].includes(
              this.conditions[key][subKey][4][1]
            )
          ) {
            let old = this.conditions[key][subKey][4][2]
            if (typeof old === 'string') {
              this.conditions[key][subKey][4][2] = [
                old.split(' to ')[0],
                old.split(' to ')[1]
              ]
            }
          }
        })
      })
    },

    checkAddPropertyButton(condI, condItemI) {
      let shouldBeDisplayed = ['events', 'metric'].includes(
        this.conditions[condI][condItemI][0]
      )
      if (
        this.eventPropsButtonsDisplay[condI] !== undefined &&
        this.eventPropsButtonsDisplay[condI][condItemI] !== undefined
      ) {
        shouldBeDisplayed = this.eventPropsButtonsDisplay[condI][condItemI]
      }
      return shouldBeDisplayed
    },

    defineEventPropsButtons() {
      Object.keys(this.conditions).forEach(key => {
        Object.keys(this.conditions[key]).forEach(nestedKey => {
          if (this.eventPropsButtonsDisplay[key] === undefined) {
            this.eventPropsButtonsDisplay[key] = []
          }
          this.eventPropsButtonsDisplay[key][nestedKey] =
            this.conditions[key][nestedKey][0] === 'events'
          if (this.conditions[key][nestedKey][7] !== undefined) {
            this.eventPropsButtonsDisplay[key][nestedKey] =
              Object.keys(this.conditions[key][nestedKey][7]).length <
              this.eventPropLimit
          }
        })
      })
    },

    removeConditionSection(key) {
      this.$emit('input', this.serialize())
      this.$nextTick(() => {
        this.conditions = this.value
        this.$delete(this.conditions, key)
        this.$forceUpdate()
        this.$nextTick(() => {
          this.editor.initDOM()
          this.updateConditionJson()
        })
      })
    },

    removeConditionRow(gLoop, iLoop) {
      this.conditions = this.value
      if (
        this.getConditionLastKey(this.conditions[gLoop]) === 0 &&
        !this.singleLevel
      ) {
        delete this.conditions[gLoop]
      } else {
        delete this.conditions[gLoop][iLoop]
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
    },

    addConditionSection() {
      let lastIndex = this.getConditionLastKey(this.conditions)
      let nextIndex = 0
      if (lastIndex !== null) {
        nextIndex = parseInt(lastIndex) + 1
      }
      this.conditions[nextIndex] = { '0': {}, operator: 'AND' }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },

    serialize() {
      let form = this.serializedForm()
      if (
        form &&
        form[this.dataModelName] &&
        form[this.dataModelName].conditions
      ) {
        for (let sectionKey in form[this.dataModelName].conditions) {
          let section = form[this.dataModelName].conditions[sectionKey]
          for (let rowKey in section) {
            if (this.isDateRange(section, rowKey)) {
              let datesArr = section[rowKey][4][2].split(' to ')
              section[rowKey][4] = [
                section[rowKey][4][0],
                section[rowKey][4][1],
                datesArr
              ]
            }
          }
        }
      }

      if (form.hasOwnProperty(this.dataModelName)) {
        return form[this.dataModelName][this.dataModelAttribute]
      }
    },

    isDateRange(section, rowKey) {
      return (
        typeof section[rowKey] === 'object' &&
        undefined !== section[rowKey][4] &&
        (section[rowKey][0] === 'created_time' ||
          section[rowKey][4][0] === 'date') &&
        (section[rowKey][4][1] === 'between' ||
          section[rowKey][4][1] === 'between_time')
      )
    },

    serializedForm() {
      return $(this.$refs['form']).serializeJSON()
    },

    bindPropertiesEvents() {
      $('body').delegate('.addEventPropertyButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.addEventPropertyButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        this.addEventPropertyRow(conditionIndex, conditionItemIndex)
      })
      $('body').delegate('.removeEventPropertyButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.removeEventPropertyButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        let conditionItemPropertyIndex = elem.data('event-property-index')
        this.removeEventPropertyRow(
          conditionIndex,
          conditionItemIndex,
          conditionItemPropertyIndex
        )
      })
      $('body').delegate('.conditionRow input', 'keyup', event => {
        this.updateConditionJson()
      })
      $('body').delegate('.addEventGoalValueButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.addEventGoalValueButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        this.addEventValuePropertyRow(conditionIndex, conditionItemIndex)
      })
      $('body').delegate('.removeEventGoalValueButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.removeEventGoalValueButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        this.removeEventValuePropertyRow(conditionIndex, conditionItemIndex)
      })
    }
  },
  watch: {
    menuData() {
      this.$nextTick(function() {
        setTimeout(() => {
          this.editor.initDOM()
          if (this.preview) {
            setTimeout(() => {
              $('input,select')
                .prop('readonly', true)
                .on('mousedown', e => {
                  e.preventDefault()
                })
            }, 100)
          }
        }, 500)
      })
    }
  }
}
</script>

<style scoped>
.addConditionRowWrapper {
  border-top: 1px solid #d9dada;
  padding: 14px 14px 5px;
}
.condition-button-wrapper {
  margin: 11px 20px;
}
.no-data {
  font-size: 14px;
}
.segmentsWrapper {
  border: 0 none !important;
}
.segmentConditions {
  padding: 0 !important;
}
.conditionOuterWrapper {
  padding: 0 !important;
  position: relative;
}
.addRowButton {
  font-weight: normal !important;
}
>>> .addEventPropertyButton,
>>> .addEventGoalValueButton {
  font-weight: normal !important;
  margin-bottom: 8px;
  margin-left: 0px;
  margin-right: 5px;
}
>>> .removeEventPropertyButton,
>>> .removeEventGoalValueButton {
  font-weight: normal !important;
  color: #a7acba !important;
  border: none;
  padding-left: 0;
  padding-right: 0;
  margin-top: 1px;
}
>>> .removeEventPropertyButton:hover,
>>> .removeEventGoalValueButton:hover {
  background-color: unset !important;
  color: #a7acba !important;
}
.addSectionButton {
  border: 1px solid #d9dada;
  background: #f8fafc;
  width: 100%;
  color: #1d87c8;
  font-weight: normal;
  height: 46px;
  margin-top: 20px;
}
>>> .no-delete .delete {
  display: none;
}
form {
  min-height: 160px;
}
.invisible {
  visibility: hidden;
}
>>> .el-loading-spinner {
  top: 150px;
}

>>> .item-text {
  width: fit-content;
  height: fit-content;
}

>>> .iconp-IconBellStar:before {
  content: url('../../img/icon/icon-bell-star.svg');
  scale: 1.08;
}

>>> .jsEntityName {
  width: 160px !important;
}

>>> .jsEntityEventPropertiesWrapper.jsEntityEventPropertyValueNameWrapper {
  padding-bottom: 8px;

  .text {
    line-height: 38px;
  }

  input[type='text'] {
    width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/ConditionsEditor.vue